import React, { useState } from 'react';
import { useEffectOnce } from 'react-use';
import { useNavigate } from 'react-router-dom';

import { NotificationContainer } from './Notifications.style';
import TimeConverter from '../../utils/TimeConverter';
import { getOneTeam, markOneAsRead } from '../../utils/api/axiosCalls';
import { closeLoader, showLoader } from '../../core/store/slices/loaderSlice';
import Spinner from '../../components/Spinner/Spinner';
import { useAppDispatch } from '../../core/hooks/hooks';

type notificationCompType = {
	notification: any;
	size?: string;
	index?: number;
};

const NotificationComp = ({ notification, size, index }: notificationCompType) => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const [loader, setLoading] = useState(true);

	useEffectOnce(() => {
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	});

	const getRoundbySlug = async (roundSlug, notificationSlug) => {
		dispatch(showLoader({ show: true, animation: <Spinner /> }));
		try {
			markOneAsRead(notificationSlug);
			navigate(`/rounds/activities/${roundSlug}?type=tournament`);
		} catch (error) {}

		dispatch(closeLoader());
	};

	const getTeambySlug = async (teamSlug, notificationSlug) => {
		dispatch(showLoader({ show: true, animation: <Spinner /> }));
		try {
			markOneAsRead(notificationSlug);
			const res = await getOneTeam(teamSlug);
			navigate(`/teams/team-profile?slug=${res.record.slug}`, { state: res.record });
		} catch (error) {}
		dispatch(closeLoader());
	};

	const geTournamentbySlug = async (roundSlug, notificationSlug) => {
		dispatch(showLoader({ show: true, animation: <Spinner /> }));
		try {
			markOneAsRead(notificationSlug);
			navigate(`tournament`);
		} catch (error) {}

		dispatch(closeLoader());
	};

	const handelNavigation = (notificationType, key, notificationSlug?) => {
		switch (notificationType) {
			case 'round_started':
				getRoundbySlug(key, notificationSlug);
				break;
			case 'score_published':
				geTournamentbySlug(key, notificationSlug);
				break;
			case 'user_assigned_to_team':
				getTeambySlug(key, notificationSlug);
				break;
			default:
			// code block
		}
	};

	return (
		<NotificationContainer
			className={(notification.type === 'round_started' || notification.type === 'user_assigned_to_team') && `pointer`}
			onClick={() => handelNavigation(notification.type, notification.key, notification.slug)}
			size={size}
			active={`${notification.status}`}
			key={index}
		>
			<p className="dot"></p>
			<div className="w-[100%]">
				<div className="notiHead">
					<p className="head">
						{size === 'mini' ? notification?.title.slice(0, 35) + (notification?.title.length > 35 ? '...' : '') : notification?.title}
					</p>
					<span className="time">{TimeConverter.converter(notification.ago)} </span>
				</div>
				<p className="des">
					{size === 'mini'
						? notification.description.slice(0, 100) + (notification?.description?.length > 100 ? '...' : '')
						: notification.description}
				</p>
			</div>
		</NotificationContainer>
	);
};

export default NotificationComp;
